module.exports = __webpack_public_path__ + "5407a9c561b0b34bc2507d00bdeb034c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BE.svg
// module id = kce8
// module chunks = 0